import { render, staticRenderFns } from "./NewEditCondition.vue?vue&type=template&id=4791f52c&"
import script from "../../models/push-notifications/new-edit-condition.ts?vue&type=script&lang=ts&"
export * from "../../models/push-notifications/new-edit-condition.ts?vue&type=script&lang=ts&"
import style0 from "./NewEditCondition.vue?vue&type=style&index=0&id=4791f52c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports